// React
import React from "react";

// DateTime
const { DateTime } = require("luxon");

export default function UserIndexItem({ user = {}, ...props }) {

  function formatTime(unixTime) {
    const timeObject = DateTime.fromMillis(parseInt(unixTime)).setZone("America/Los_Angeles");
    const timeString = timeObject.toLocaleString(DateTime.DATE_MED);
    return (
        <p>{timeString}</p>
    )
  }

  return (
    <div
      className="user-index-item"
      onClick={() => {
        props.viewUserAction(user.email);
      }}
    >
      <div>
        <img className="avatar sm" src={user.picture} />
        <h3>{user.fullName}</h3>
        <p>{user.email}</p>
      </div>
      <div>
        <p>{user.role}</p>
      </div>
    </div>
  );
}
